import {
  createSchoolShiftAsync,
  deleteSchoolShiftAsync,
  getAllSchoolShiftByLicenseAsync,
  getSchoolShiftByIdAsync,
  updateSchoolShiftAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSchoolShiftAsync = () =>
  useMutation(createSchoolShiftAsync);

export const useGetSchoolShiftByIdAsync = () =>
  useMutation(getSchoolShiftByIdAsync);

export const useGetAllSchoolShiftByLicenseAsync = () =>
  useMutation(getAllSchoolShiftByLicenseAsync);

export const useUpdateSchoolShiftAsync = () =>
  useMutation(updateSchoolShiftAsync);

export const useDeleteSchoolShiftAsync = () =>
  useMutation(deleteSchoolShiftAsync);
